module.exports = __webpack_public_path__ + "static/media/blog-page-3.3da4a70f.jpg";